import { DataService } from '../../services/data.service';
import { observable, action, toJS, } from 'mobx';
import { Injectable } from '@angular/core';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';
import { pushToObject, removeStingArray, pushObjArray, ConvertService, pushToArray } from 'src/app/services/convert.service';
import { ILesson, IModule, IProgramLevel } from 'src/app/interfaces/resource';
import { groupBy, orderBy, groupByArray } from 'src/app/services/mapping.service';
import { AuthService } from 'src/app/auth/auth.service';
import { IProgramReading } from 'src/app/interfaces/book-store';

@Injectable()
export class CurriculumStore {
    @observable data: any;
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;

    @observable selectedProgram: any = null;
    @observable selectedLevel: any = null;

    constructor(private ds: DataService,
        private router: Router
        , private auth: AuthService) {
    }

    @action
    async fetchProgram(programKey) {
        const doc = await this.ds.collection(COLLECTION_NAME.PROGRAM).doc(programKey).get().toPromise();
        this.selectedProgram = pushToObject(doc);
        return this.selectedProgram;
    }

    @action
    async removeModule(module: IModule, lessonKey, levelKey: any, programKey: any, uid, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const programRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.PROGRAM).doc(programKey);
        const levelRef = programRef.collection('levels').doc(levelKey);
        const LEVEL_DATA = pushToObject(await levelRef.get());
        const ACTIVITY_DATA = await this.ds.activityByModuleColRef(module.key).get().toPromise();
        const { activityKey, moduleKey } = LEVEL_DATA;
        let activityKeyData: any[] = activityKey || [];
        let moduleKeyData: any[] = removeStingArray(moduleKey || [], module.key);
        ACTIVITY_DATA.forEach(data => {
            const { id } = data;
            activityKeyData = removeStingArray(activityKeyData, id);
        })
        batch.update(levelRef, {
            activityKey: activityKeyData || [],
            activityRef: activityKeyData ? activityKeyData.map(m => ({
                key: this.ds.createId(),
                ref: this.ds.activityColRef().doc(m).ref,
                activityKey: m,
                lessonKey: lessonKey,
                levelKey: levelKey,
                programKey: programKey,
            })) : [],
            moduleKey: moduleKeyData || [],
            moduleRef: moduleKeyData ? moduleKeyData.map(m => ({
                key: this.ds.createId(),
                moduleKey: m,
                ref: this.ds.moduleRef().doc(m).ref,
                lessonKey: lessonKey,
                levelKey: levelKey,
                programKey: programKey,
            })) : [],
            updated_by: uid,
            updated_byRef: this.ds.userProfileRef().doc(uid).ref,
            updated_at: new Date(),
            total_module: firebase.firestore.FieldValue.increment(-1),
            total_activity: firebase.firestore.FieldValue.increment(-1)
        });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async addModule(module: IModule, lessonKey, levelKey: any, programKey: any, uid, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const programRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.PROGRAM).doc(programKey);
        const levelRef = programRef.collection('levels').doc(levelKey)
        const lessonRef = levelRef.collection('lessons').doc(lessonKey);
        const lessonActivityRef = this.ds.batchCollectionRef().collection('program_module_activities');

        const MODULE_ACTIVITY_DATA = await this.ds.activityByModuleColRef(module.key).get().toPromise();
        const LEVEL_DOC = await this.ds.adprogramCollectRef().doc(programKey).collection('levels').doc(levelKey).get().toPromise();
        const LEVEL_DATA = pushToObject(LEVEL_DOC)
        const LESSON_DATA = pushToObject(await lessonRef.get());
        const { activityRef, pageKey } = LESSON_DATA;
        let activityRefData: any[] = activityRef || [];
        let skillModuleKey: any = null;
        let skillActivityKey: any = null;
        MODULE_ACTIVITY_DATA.forEach(data => {
            const { id } = data;
            const { activityTypeKey, activityTypeName, skillKey, skillName, moduleKey, } = data.data();
            const item = {
                key: id,
                ref: this.ds.activityColRef().doc(id).ref,
                lessonKey: lessonKey,
                levelKey: levelKey,
                programKey: programKey,
                activityTypeKey: activityTypeKey,
                activityTypeName: activityTypeName,
                skillKey,
                skillName: skillName || skillKey,
                moduleKey: moduleKey,
                pageKey: ConvertService.pageKey(),
                lessonPageKey: pageKey,
            }
            skillModuleKey = skillKey;
            skillActivityKey = id;
            activityRefData = pushObjArray(activityRefData, item);
        })
        const moduleActivityData = activityRefData.filter(m => m.moduleKey === module.key)[0]
        const ACTIVITY_GROUP = groupBy(activityRefData, "moduleKey", "pageKey")
        const MODULE_DATA_REF = ACTIVITY_GROUP.map(m => ({
            key: m.moduleKey,
            ref: this.ds.moduleRef().doc(m.moduleKey).ref,
            lessonKey: m.lessonKey,
            levelKey: m.levelKey,
            programKey: m.programKey,
            skillKey: m.skillKey || null,
            skillName: m.skillName || null,
            activityTypeKey: m.activityTypeKey,
            activityTypeName: m.activityTypeName,
            defaultActivityKey: m.key,
            defaultActivityRef: this.ds.activityColRef().doc(m.key).ref,
            lessonName: LESSON_DATA.name,
            lessonPageKey: pageKey,
            pageKey: ConvertService.pageKey(),
        }))
        const moduleMovementData = MODULE_DATA_REF.find(m => m.key === module.key);
        if (moduleMovementData) {
            const movementKey = this.ds.createId();
            const moduleData = {
                key: movementKey,
                moduleRef: moduleMovementData,
                activityRef: moduleActivityData || null,
                pageKey: ConvertService.pageKey(),
                updated_by: uid,
                updated_byRef: this.ds.userProfileRef().doc(uid).ref,
                updated_at: new Date(),
            }
            batch.set(lessonActivityRef.doc(movementKey), moduleData)
        }

        const lessonItem = {
            activityKey: activityRefData.map(m => (m.key)),
            activityRef: activityRefData,
            moduleKey: MODULE_DATA_REF.map(m => (m.key)),
            moduleRef: MODULE_DATA_REF,
            updated_by: uid,
            updated_byRef: this.ds.userProfileRef().doc(uid).ref,
            updated_at: new Date(),
            updated_skill: skillModuleKey,
            updated_activity_key: skillActivityKey,
        }
        const levelLessonRef = LEVEL_DATA.lessonRef || [];
        const LEVEL_LESSON_DATA_REF = levelLessonRef.map(m => {
            if (m.key !== lessonKey) return m;
            const row = {
                ...m,
                activityKey: activityRefData[0].key,
                activityRef: this.ds.activityColRef().doc(activityRefData[0].key).ref,
                activityTypeKey: activityRefData[0].activityTypeKey,
                activityTypeName: activityRefData[0].activityTypeName,
                filename: LESSON_DATA.filename,
                fileurl: LESSON_DATA.fileurl,
                description: LESSON_DATA.description,
            }
            return row;
        })
        const LEVEL_UPDATE_DATA = {
            total_module: firebase.firestore.FieldValue.increment(MODULE_ACTIVITY_DATA.size),
            total_activity: firebase.firestore.FieldValue.increment(MODULE_ACTIVITY_DATA.size),
            lessonRef: LEVEL_LESSON_DATA_REF,
            lessonKey: LEVEL_LESSON_DATA_REF.map(m => (m.key)),
            updated_by: uid,
            updated_byRef: this.ds.userProfileRef().doc(uid).ref,
            updated_at: new Date(),
        }
        batch.update(lessonRef, lessonItem);
        batch.update(levelRef, LEVEL_UPDATE_DATA)
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async removeLesson(lesson: ILesson, levelKey: any, programKey: any, uid, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const programRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.PROGRAM).doc(programKey);
        const programLevelRef = programRef.collection('levels').doc(levelKey);
        const programLessonRef = programLevelRef.collection('lessons').doc(lesson.key);

        const lessonActivitiesDocs = await this.ds.programRef().doc(programKey)
            .collection('levels').doc(levelKey)
            .collection('lessons').doc(lesson.key).collection('lesson_activities').get().toPromise();

        const lessonActivitiesData: any[] = pushToArray(lessonActivitiesDocs)
        const levelData = await this.ds.programRef().doc(programKey).collection('levels').doc(levelKey).get().toPromise();
        const levelDoc = pushToObject(levelData);
        const lessonSkills: any[] = groupByArray(lessonActivitiesData, 'default_skill');
        const skillActivity: any[] = lessonSkills.map(m => {
            const { default_skill } = m;
            const total = lessonActivitiesData.filter(r => r.default_skill === default_skill).length;
            return { key: default_skill, total: total };
        })

        lessonActivitiesData.forEach(m => {
            const { default_skill } = m;
            batch.delete(programLessonRef.collection('lesson_activities').doc(m.key));
            batch.delete(programLessonRef.collection('skills').doc(default_skill).collection('skill_activities').doc(m.key));
        })

        batch.delete(programLessonRef)
        const { lessonRef } = levelDoc;
        const lessonRefData = (lessonRef || []).filter(m => m.key !== lesson.key);
        const lessonKeyData = lessonRefData.map(m => (m.key))
        skillActivity.forEach(s => {
            batch.update(programLevelRef, {
                [`total_${s.key}`]: firebase.firestore.FieldValue.increment(s.total * -1),
            });
        })
        batch.update(programLevelRef, {
            lessonKey: lessonKeyData,
            lessonRef: lessonRefData,
            updated_by: uid,
            updated_byRef: this.ds.userProfileRef().doc(uid).ref,
            updated_at: this.ds.serverTimestamp(),
            total_lesson: firebase.firestore.FieldValue.increment(-1),
            total_activity: firebase.firestore.FieldValue.increment(lessonActivitiesData.length * -1),
        });

        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }



    @action
    async addLesson(lesson: ILesson, levelKey: any, programKey: any, uid, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const programRef = this.ds.batchCollectionRef().collection(COLLECTION_NAME.PROGRAM).doc(programKey);
        const programLevelRef = programRef.collection('levels').doc(levelKey);
        const programLessonRef = programLevelRef.collection('lessons').doc(lesson.key);

        const lessonActivities = await this.ds.moduleByLessonRef(lesson.key).get().toPromise();
        const lessonActivitiesData: any[] = orderBy(pushToArray(lessonActivities), "page_key", "asc");
        if (lessonActivities.empty) {
            alert("Sorry invalid activity in this lesson. You can't add lesson without activities!")
            callback(false, null)
            return;
        }
        const levelData = await this.ds.programRef().doc(programKey).collection('levels').doc(levelKey).get().toPromise();

        const levelDoc = pushToObject(levelData);

        const lessonSkills: any[] = groupByArray(lessonActivitiesData, 'default_skill');
        const skillActivity: any[] = lessonSkills.map(m => {
            const { default_skill } = m;
            const total = lessonActivitiesData.filter(r => r.default_skill === default_skill).length;
            return { key: default_skill, total: total };
        })

        lessonActivitiesData.forEach(m => {
            const { default_skill } = m;
            batch.set(programLessonRef.collection('lesson_activities').doc(m.key), {
                ...m,
                levelKey: this.selectedLevel.key,
                programKey: this.selectedProgram.key,
                lessonName: lesson.name,
                created_at: this.ds.serverTimestamp(),
                created_by: uid,
            }, { merge: true });
            batch.set(programLevelRef.collection('skills').doc(default_skill).collection('skill_activities').doc(m.key), {
                ...m,
                levelKey: this.selectedLevel.key,
                programKey: this.selectedProgram.key,
                lessonName: lesson.name,
                created_at: this.ds.serverTimestamp(),
                created_by: uid,
            }, { merge: true })
        })
        skillActivity.forEach(s => {
            batch.update(programLevelRef, {
                [`total_${s.key}`]: firebase.firestore.FieldValue.increment(s.total),
            });
            batch.set(programLessonRef, {
                [`total_${s.key}`]: firebase.firestore.FieldValue.increment(s.total),
            }, { merge: true });
        })
        const activityData = lessonActivitiesData.map(m => m.activityKey && ({ key: m.activityKey, activityTypeKey: m.activityTypeKey, skillKey: m.default_skill }));
        const programLesson = {
            key: lesson.key,
            name: lesson.name,
            description: lesson.description || null,
            filename: lesson.filename || null,
            fileurl: lesson.fileurl || null,
            updated_activity_key: lessonActivitiesData[0].key,
            updated_at: this.ds.serverTimestamp(),
            updated_by: uid,
            updated_byRef: this.ds.userRef().doc(uid).ref,
            updated_skill: lessonActivitiesData[0].default_skill,
            total_activity: firebase.firestore.FieldValue.increment(lessonActivitiesData.length),
            page_key: ConvertService.pageKeyMs(),
            pageKey: ConvertService.pageKeyMs(),
            activityData: activityData,
        }
        const lessonData = {
            key: lesson.key,
            ref: this.ds.lessonColRef().doc(lesson.key).ref,
            name: lesson.name,
            description: lesson.description || null,
            filename: lesson.filename || null,
            fileurl: lesson.fileurl || null,
            pageKey: ConvertService.pageKey(),
            page_key: ConvertService.pageKeyMs(),
        }

        batch.set(programLessonRef, programLesson, { merge: true })

        const { lessonRef } = levelDoc;
        const lessonRefData = pushObjArray(lessonRef || [], lessonData)
        const lessonKeyData = lessonRefData.map(m => (m && m.key))

        // batch.update(programLevelRef, {
        //     lessonKey: lessonKeyData,
        //     lessonRef: lessonRefData,
        //     updated_by: uid,
        //     updated_byRef: this.ds.userProfileRef().doc(uid).ref,
        //     updated_at: this.ds.serverTimestamp(),
        //     total_lesson: firebase.firestore.FieldValue.increment(1),
        //     total_activity: firebase.firestore.FieldValue.increment(lessonActivitiesData.length),
        // });

        // batch.commit().then(() => {
        //     callback(true, null);
        // }).catch((error) => {
        //     alert(error);
        //     callback(false, error)
        // }).finally(() => {
        //     this.process = false;
        // })
    }


    @action
    async removeLevelProgram(item: IProgramLevel, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { programKey } = item;
        const ref = this.ds.batchCollectionRef().collection(COLLECTION_NAME.PROGRAM).doc(programKey);
        const programData = pushToObject(await this.ds.programRef().doc(programKey).get().toPromise());
        const { levelRef } = programData
        const programLevelRef = levelRef.filter(m => m.key !== item.key);
        const programLevelKey = programLevelRef.map(m => (m.key))

        batch.delete(ref.collection('levels').doc(item.key));
        batch.update(ref, {
            levelKey: programLevelKey,
            levelRef: programLevelRef,
            updated_by: item.updated_by,
            updated_byRef: item.updated_byRef,
            updated_at: item.updated_at,
        });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async addLevel(item: IProgramLevel, callback) {
        this.process = true;
        const batch = this.ds.batch();
        const { programKey } = item;
        const ref = this.ds.batchCollectionRef().collection(COLLECTION_NAME.PROGRAM).doc(programKey);
        const programData = pushToObject(await this.ds.programRef().doc(programKey).get().toPromise());
        const { levelRef } = programData
        const programLevelRef = pushObjArray(levelRef || [], { key: item.key, name: item.name, order: item.order, hour: item.hour, price: item.price, description: item.description })
        const programLevelKey = programLevelRef.map(m => (m.key))
        batch.set(ref.collection('levels').doc(item.key), item, { merge: true })
        batch.update(ref, {
            levelKey: programLevelKey,
            levelRef: programLevelRef,
            updated_by: item.updated_by,
            updated_byRef: item.updated_byRef,
            updated_at: item.updated_at,
        });
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    async fetchProgramData(programKey) {
        const doc = await this.ds.programRef().doc(programKey).get().toPromise();
        return pushToObject(doc);
    }

    @observable fetchProgramLevelRef: any = null;
    @action
    fetchProgramLevel(programKey, callback?) {
        this.loading = true;
        this.fetchProgramLevelRef = this.ds.programRef().doc(programKey)
            .collection('levels', ref => ref.orderBy("order"))
            .valueChanges().subscribe(docs => {
                this.data = docs
                this.loading = false;
                callback && callback(docs);
            })
    }

    @action
    async fetchProgramLevelData(programKey, levelKey) {
        const doc = await this.ds.programRef().doc(programKey).collection('levels').doc(levelKey).get().toPromise();
        this.selectedLevel = pushToObject(doc);
        return this.selectedLevel;
    }


    @observable fetchProgramLessonsRef: any = null;
    @action
    fetchProgramLessons(programKey, levelKey, callback?) {
        this.loading = true;
        this.data = [];
        this.fetchProgramLessonsRef = this.ds.programRef().doc(programKey)
            .collection('levels').doc(levelKey)
            .collection('lessons', ref => ref.orderBy("pageKey"))
            .valueChanges().subscribe(docs => {
                this.data = docs
                this.loading = false;
                if (!docs) {
                    this.router.navigate([`/404`])
                }
                callback && callback(docs)
            })
    }

    @action
    fetchProgramLevelReading(programKey, levelKey) {
        this.loading = true;
        this.ds.programRef().doc(programKey).collection('levels').doc(levelKey).collection('level_reading').valueChanges().subscribe(docs => {
            this.data = docs
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }


    @action
    addReadingBook(reading: IProgramReading, callback) {
        this.ds.programRef().doc(reading.programKey)
            .collection('levels').doc(reading.levelKey)
            .collection('level_reading').doc(reading.key).set(reading)
            .then(() => {
                callback(true, null);
            }).catch((error) => {
                alert(error);
                callback(false, error)
            }).finally(() => {
                this.process = false;
            })
    }


    @action
    removeReading(programKey, levelKey, readingKey, callback) {
        this.ds.programRef().doc(programKey)
            .collection('levels').doc(levelKey)
            .collection('level_reading').doc(readingKey).delete()
            .then(() => {
                callback(true, null);
            }).catch((error) => {
                alert(error);
                callback(false, error)
            }).finally(() => {
                this.process = false;
            })
    }

    @action
    fetchProgramModules(programKey, levelKey, lessonKey) {
        this.loading = true;
        this.ds.programRef().doc(programKey)
            .collection('levels').doc(levelKey)
            .collection('lessons').doc(lessonKey)
            .valueChanges().subscribe(docs => {
                this.data = docs
                this.loading = false;
                if (!docs) {
                    this.router.navigate([`/404`])
                }
            })
    }

    @action
    fetchData(programKey) {
        this.loading = true;
        this.ds.adprogramCollectRef().doc(programKey).valueChanges().subscribe(docs => {
            this.data = docs
            this.loading = false;
            if (!docs) {
                this.router.navigate([`/404`])
            }
        })
    }

    @action
    fetchLessons(programKey, levelKey) {
        this.loading = true;
        this.ds.adprogramCollectRef().doc(programKey).collection('levels').doc(levelKey).valueChanges().subscribe(docs => {
            this.data = docs
            this.loading = false;
            if (!docs) {
                this.router.navigate([`/404`])
            }
        })
    }

    @action
    fetchModules(programKey, levelKey, lessonKey) {
        this.loading = true;
        this.ds.adprogramCollectRef().doc(programKey)
            .collection('levels').doc(levelKey)
            .collection('lessons').doc(lessonKey)
            .valueChanges().subscribe(docs => {
                this.data = docs
                this.loading = false;
                if (!docs) {
                    this.router.navigate([`/404`])
                }
            })
    }

    @action
    fetchModule(programKey, levelKey, callback) {
        this.ds.adprogramCollectRef().doc(programKey).collection('levels').doc(levelKey).valueChanges().subscribe(doc => {
            callback(doc)
        })
    }

}
